export default "__VITE_ASSET__Cgjwo_jT__"